import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/axiosInstance';

const API = process.env.REACT_APP_API_BASE_URL?.replace(/\/+$/, '') || 'http://localhost:3001';

export const createInquiry = createAsyncThunk(
  'inquiry/createInquiry',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await api.post('/api/merchant/create', payload);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: 'Failed to submit inquiry' });
    }
  }
);

export const fetchInquiries = createAsyncThunk(
  'inquiry/fetchInquiries',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get('/api/merchant/merchant-inquiry');
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: 'Unable to fetch inquiries' });
    }
  }
);

export const fetchCountries = createAsyncThunk(
  'inquiry/fetchCountries',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get('/api/master/countries');
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: 'Failed to fetch countries' });
    }
  }
);

export const fetchStates = createAsyncThunk(
  'inquiry/fetchStates',
  async ({ countryId }, { rejectWithValue }) => {
    try {
      const { data } = await api.get('/api/master/states', { params: { countryId } });
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: 'Failed to fetch states' });
    }
  }
);

export const fetchDistricts = createAsyncThunk(
  'inquiry/fetchDistricts',
  async ({ stateId }, { rejectWithValue }) => {
    try {
      const { data } = await api.get('/api/master/districts', { params: { stateId } });
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: 'Failed to fetch districts' });
    }
  }
);

export const fetchLocalAreas = createAsyncThunk(
  'inquiry/fetchLocalAreas',
  async ({ districtId }, { rejectWithValue }) => {
    try {
      const { data } = await api.get('/api/master/local-areas', { params: { districtId } });
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: 'Failed to fetch local areas' });
    }
  }
);

export const fetchBusinessTypes = createAsyncThunk(
  'inquiry/fetchBusinessTypes',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get('/api/master/business-types');
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: 'Failed to fetch business types' });
    }
  }
);

export const fetchBusinessCategories = createAsyncThunk(
  'inquiry/fetchBusinessCategories',
  async ({ businessTypeId }, { rejectWithValue }) => {
    try {
      const { data } = await api.get('/api/master/business-categories', { params: { businessTypeId } });
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: 'Failed to fetch business categories' });
    }
  }
);

export const fetchBusinessServices = createAsyncThunk(
  'inquiry/fetchBusinessServices',
  async ({ businessTypeId }, { rejectWithValue }) => {
    try {
      const { data } = await api.get('/api/master/business-services', { params: { businessTypeId } });
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: 'Failed to fetch business services' });
    }
  }
);


